// tslint:disable:max-line-length
// tslint:disable:object-literal-sort-keys
import * as React from 'react';

import { ITab } from '@cian/components';
import { PikTabGroup } from '../../ui/pik_tab_group/pik_tab_group';
import { VideoPlayer } from '../video-player';
import { TABS_ICONS } from './icons';
import { StandardTabId, TabPage } from './tab_page/tab_page';
import { TABS_VIDEOS } from './videos';
import { connect } from 'react-redux';
import { IApplicationState } from '../../types/redux';
import { changeTabs } from '../../actions/location';
import { TComponentWithTabsProps } from '../../types/tabs';

import * as styles from './standard.css';
import * as commonStyles from '../../common/common.css';

export class StandardComponent extends React.PureComponent<TComponentWithTabsProps> {
  private tabs: ITab[] = [
    { id: 'yardPark', title: 'Двор-парк' },
    { id: 'decoration', title: 'Отделка' },
    { id: 'facades', title: 'Фасады' },
    { id: 'elevators', title: 'Лифт' },
    { id: 'entrances', title: 'Подъезд' },
    { id: 'sockets', title: 'Розетки' },
    { id: 'lobby', title: 'Лобби' },
    { id: 'steps', title: 'Ступени' },
    { id: 'howItsDone', title: 'Как это сделано' },
    { id: 'playability', title: 'Игры, в которые играют люди' },
  ];

  public render() {
    const {
      tabs: { standard: activeTab },
    } = this.props;

    return (
      <div>
        <p className={commonStyles['pik-standard-description']}>
          Мы&nbsp;хотим, чтобы наши клиенты каждый день убеждались, что сделали правильный выбор. Как этого добиться?
          Очень просто. Надо строить дома, в&nbsp;которые можно по-настоящему влюбиться. Это наша философия. В&nbsp;2015
          году мы&nbsp;решили, что наше доступное жилье должно подняться на&nbsp;новый уровень.
        </p>

        <PikTabGroup
          activeTab={activeTab}
          onTabClick={this.handleTabToggle}
          tabs={this.tabs}
          containerStyle={styles['tabs']}
        />

        {this.renderVideoPlayer(activeTab)}
        {this.renderTabsPage(activeTab)}
      </div>
    );
  }

  private renderVideoPlayer = (tab: StandardTabId) => {
    const videoSettings = TABS_VIDEOS[tab];
    const { video, videoStartSecond } = videoSettings;

    return <VideoPlayer videoURL={video} startSecond={videoStartSecond} />;
  };

  private handleTabToggle = (value: StandardTabId) => this.props.changeTabs({ ...this.props.tabs, standard: value });

  private renderTabsPage = (tab: StandardTabId): React.ReactNode => {
    const icons = TABS_ICONS[tab];

    const tabs: { [key: string]: React.ReactNode } = {
      yardPark: (
        <TabPage
          id="yardPark"
          title="Самый обычный двор-парк"
          description="Представьте себе двор-парк. С&nbsp;ландшафтным дизайном, Wi-Fi, игровыми и&nbsp;спортивными площадками, удобными скамейками, продуманным освещением. Двор без автомобилей, но&nbsp;с&nbsp;велодорожками и&nbsp;бульварами. Всё это&nbsp;&mdash; самый обычный двор новостройки от&nbsp;ПИК."
          icons={icons}
        />
      ),
      decoration: (
        <TabPage
          id="decoration"
          title="Готовая отделка"
          description="Что такое готовая отделка от&nbsp;ПИК? Это экономия времени, сил и&nbsp;семейного бюджета! Вам остаётся оформить интерьеры на&nbsp;свой вкус и&nbsp;наполнить дом теплом и&nbsp;уютом."
          icons={icons}
        />
      ),
      facades: (
        <TabPage
          id="facades"
          title="Долговечные фасады"
          description="Яркие фасады&nbsp;&mdash; визитная карточка домов ПИК. Их&nbsp;невозможно испортить даже кондиционерами. Они останутся такими&nbsp;же красивыми и&nbsp;аккуратными в&nbsp;течение долгих лет."
          icons={icons}
        />
      ),
      elevators: (
        <TabPage
          id="elevators"
          title="Скоростные лифты"
          description={
            <span>
              Кто быстрее поднимется на&nbsp;12&nbsp;этаж: профессиональный бегун или маленькая девочка
              на&nbsp;скоростном лифте? Мы&nbsp;решили провести невероятный эксперимент в&nbsp;одном из&nbsp;домов ПИК.
              Узнайте, кто победит в&nbsp;этом соревновании.
              <br />
              На&nbsp;старт, внимание, марш!
            </span>
          }
          icons={icons}
        />
      ),
      entrances: (
        <TabPage
          id="entrances"
          title="Просторные подъезды"
          description="Одно из&nbsp;преимуществ домов ПИК&nbsp;&mdash; просторные подъезды. Они настолько вместительны, что в&nbsp;любой момент могут превратиться в&nbsp;настоящий концертный зал. А&nbsp;что если устроить вечеринку с&nbsp;зажигательными танцами? Без проблем!"
          icons={icons}
        />
      ),
      sockets: (
        <TabPage
          id="schools"
          title="Большое количество розеток"
          description="Нехватка розеток&nbsp;&mdash; типичная бытовая проблема. Но&nbsp;только не&nbsp;в&nbsp;домах ПИК! Мы&nbsp;позаботились о&nbsp;каждом члене семьи, поэтому даже в&nbsp;однокомнатной квартире установлено не&nbsp;менее 17&nbsp;розеток. Теперь их&nbsp;точно хватит на&nbsp;всех!"
          icons={icons}
        />
      ),
      lobby: (
        <TabPage
          id="schools"
          title="Лобби с высокими потолками"
          description="Просторные и&nbsp;высокие потолки в&nbsp;подъездах домов ПИК&nbsp;&mdash; это красиво и&nbsp;удобно. Но&nbsp;однажды этот положительный фактор может сыграть с&nbsp;вами веселую шутку. Такое случилось с&nbsp;жителями нашего дома."
          icons={icons}
        />
      ),
      steps: (
        <TabPage
          id="schools"
          title="Cквозной подъезд без ступеней и пандусов"
          description="Посмотрите, как легко жителям домов ПИК пройти и&nbsp;даже проехать мимо друг друга благодаря отсутствию ступеней в&nbsp;наших подъездах! Вход в&nbsp;подъезд&nbsp;&mdash; сквозной, со&nbsp;стороны двора и&nbsp;со&nbsp;стороны улицы. Теперь дети могут выйти на&nbsp;прогулку во&nbsp;двор, минуя проезжую часть."
          icons={icons}
        />
      ),
      howItsDone: (
        <TabPage
          id="schools"
          title="Дом для каждого: как это сделано"
          description={
            <span>
              Как возводятся жилые комплексы в&nbsp;России?
              <br />
              Какие технологии используются в&nbsp;строительстве?
              <br />
              Кто контролирует все процессы сборки?
              <br />
              Какие дизайнерские решения предпочитают застройщики?
              <br />
              <br />
              Узнайте ответы на&nbsp;эти и&nbsp;другие вопросы в&nbsp;фильме &laquo;Дом для каждого: как это
              сделано&raquo;.
            </span>
          }
          icons={icons}
        />
      ),
      playability: (
        <TabPage
          id="playability"
          title="Playability"
          description={
            <span>
              Фильм «Игры, в которые играют люди» рассказывает о концепции Playability, согласно которой современное
              жилое пространство должно быть устроено так, чтобы играть в нём не надоедало никогда — это самый простой
              путь к счастью жителей современного города.
            </span>
          }
          icons={icons}
        />
      ),
    };

    return tabs[tab];
  };
}

export const Standard = connect(
  (state: IApplicationState) => ({
    tabs: state.tabs,
  }),
  {
    changeTabs,
  },
)(StandardComponent);
